import { handleLoadMore } from '../util/loadMore';

export default {
  init() {
    handleLoadMore();
  },
};
